import Cookies from 'js-cookie'
import { PLAYGROUND_ID_COOKIE_NAME } from './utils'

/**
 * @name exitPlayground
 * @param {string} teamSlug - The team slug in which the cookie was set.
 * @param {string} repoSlug - The repo slug in which the cookie was set.
 * @description Removes the playground from Cookies and reloads the page.
 * @returns {void}
 */
export const exitPlayground = (teamSlug: string, repoSlug: string) => {
  const url = new URL(window.location.href)
  url.searchParams.delete('playgroundId')
  Cookies.remove(PLAYGROUND_ID_COOKIE_NAME, {
    path: `/${teamSlug}/${repoSlug}`,
    domain: window.location.hostname,
  })

  window.location.replace(url.toString())
}
